import { createContext, FC, ReactNode, useState } from "react";

type AnecdotesModalContextType = {
  isOpen: boolean;
  chapterNumber: number | null;
  generatedChapterId: number | null;
  chapterTitle: string;
  openModal: (
    chapterNumber: number,
    chapterTitle: string,
    generatedChapterId?: number | null
  ) => void;
  closeModal: () => void;
};

export const AnecdotesModalContext = createContext<AnecdotesModalContextType>({
  isOpen: false,
  chapterNumber: null,
  generatedChapterId: null,
  chapterTitle: "",
  openModal: () => {},
  closeModal: () => {},
});

type AnecdotesModalProviderProps = {
  children: ReactNode;
};

export const AnecdotesModalProvider: FC<AnecdotesModalProviderProps> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [chapterNumber, setChapterNumber] = useState<number | null>(null);
  const [generatedChapterId, setGeneratedChapterId] = useState<number | null>(
    null
  );
  const [chapterTitle, setChapterTitle] = useState("");

  const openModal = (
    chNum: number,
    title: string,
    genChId?: number | null
  ) => {
    setChapterNumber(chNum);
    setGeneratedChapterId(genChId || null);
    setChapterTitle(title);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <AnecdotesModalContext.Provider
      value={{
        isOpen,
        chapterNumber,
        generatedChapterId,
        chapterTitle,
        openModal,
        closeModal,
      }}
    >
      {children}
    </AnecdotesModalContext.Provider>
  );
};
